var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M18 2c2.205 0 4 1.795 4 4s-1.795 4-4 4a4 4 0 0 1-3.105-1.481l-4.924 3q.03.237.029.481l-.004.142 5.103 3.107A4 4 0 0 1 18 14c2.205 0 4 1.795 4 4s-1.795 4-4 4a4.005 4.005 0 0 1-3.873-5.003l-4.733-2.883A4 4 0 0 1 6 16c-2.205 0-4-1.795-4-4s1.795-4 4-4c1.32 0 2.494.644 3.223 1.634l4.836-2.945A4.005 4.005 0 0 1 18 2m0 14c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2M6 10c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m12-6c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2"
})));
export default SvgGemShare;